/* eslint-disable @typescript-eslint/no-unused-vars */
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';

import {
  ApolloClientConfig,
  provideAandoAuth,
  provideAandoCoreConfig,
  WorkSpaces,
} from '@aando/core';
import { provideAandoApollo } from '@aando/core';
import { provideAandoLanguages } from '@aando/core';
import { ApolloClientCreatorService, ConfigService } from '@aando/core';

import { App } from './app/app';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { inject, provideAppInitializer } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { environment } from './environments/environment';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import localeJa from '@angular/common/locales/ja';
import { menu } from './app/common/menu/menu';

registerLocaleData(localeRu, 'ru');
registerLocaleData(localeJa, 'ja');

(async (): Promise<void> => {
  const appRef = await bootstrapApplication(App, {
    providers: [
      provideAnimations(),
      provideRouter(routes),
      provideNzConfig({
        notification: { nzPlacement: 'bottomRight', nzMaxStack: 4 },
      }),
      provideAandoCoreConfig({
        production: environment.production,
        domain: environment.domain,
        appName: 'ID',
        siteUrl: environment.siteUrl,
        profileUrl: environment.profileUrl,
        apolloClientsConfig: environment.apolloClientsConfig as ApolloClientConfig[],
        menuItems: menu,
        workspace: WorkSpaces.id,
      }),
      provideAandoApollo(),
      provideTranslateService(),
      provideAandoLanguages({
        defaultCode: 'en',
      }),
      provideAppInitializer(() => {
        const apolloCreator = inject(ApolloClientCreatorService);
        const config = inject(ConfigService);
        return apolloCreator.createClients(config.value.apolloClientsConfig);
      }),
      provideAandoAuth({
        ngx: {
          protectedRedirectUri: '/profile',
          publicRedirectUri: '/',
        },
      }),
      DatePipe,
    ],
  });
})();
